import React, { useEffect, useState, Suspense } from "react";
import { Header } from "@components/header/mobile";
import { Footer } from "@components/footer/mobile";
import { OnBoardingFooter } from "@features/membership/mobile/registration-types/shared";
import { useLocation } from "react-router-dom";
import classnames from "classnames";
import { useScrollDirectionByElement } from "@hooks/useScrollDirectionByElement";
import { MainHtmlElementContext } from "@state/context/main-html/MainHtmlElementContext";
import { isCapacitorPlatform } from "@utils/specific/capacitor";
import useSafeAreaListener from "@utils/specific/capacitor/useSafeAreaListener";
import CookieConsent from "@components-shared/CookieConsent";
import { GlobalLoader } from "@components/loader/mobile";
import { SuspendHeaderClassContext } from "@state/context/main-html/SuspendHeaderClassContext";

interface AppLayoutProps {
	children: React.ReactNode;
	hasOnboardingStyling?: boolean;
}

const AppLayout = ({ children, hasOnboardingStyling }: AppLayoutProps) => {
	const { pathname, search } = useLocation();
	const [mainRef, setMainRef] = useState<HTMLElement | null>(null);
	const safeaAreaPadding = useSafeAreaListener();

	const { scrollDirection, setShouldApplyHeaderClass } =
		useScrollDirectionByElement({
			// showOnTop: !pathname.includes("live"),
			targetRef: mainRef,
			threshold: 6,
		});

	var isLoginPage =
		pathname.includes("login") && !search.includes("isErrorPage");

	var isRegistration =
		pathname.includes("register") && !search.includes("isErrorPage");

	var isAuthPage =
		pathname.includes("auth") && !search.includes("isErrorPage");

	var isRegistrationResponsePage =
		pathname.includes("registration/success") ||
		pathname.includes("registration/error");

	var isErrorPage =
		(pathname.includes("error") || search.includes("isErrorPage")) &&
		!isRegistrationResponsePage;

	var isAccountActivationCongratulations = pathname.includes(
		"account-activation-congratulations"
	);

	useEffect(() => {
		isLoginPage =
			pathname.includes("login") && !search.includes("isErrorPage");
		isRegistration =
			pathname.includes("register") && !search.includes("isErrorPage");

		isAuthPage =
			pathname.includes("auth") && !search.includes("isErrorPage");

		isRegistrationResponsePage =
			pathname.includes("registration/success") ||
			pathname.includes("registration/error");

		isErrorPage =
			pathname.includes("error") || search.includes("isErrorPage");

		isAccountActivationCongratulations = pathname.includes(
			"account-activation-congratulations"
		);
	}, [pathname, search]);

	const appClassName = classnames(
		"l--root l__app",
		{
			"l--root--auth l__app--auth": !isErrorPage && isAuthPage,
			/* "l--root--marketing l__app--marketing":
				!isErrorPage &&
				(isLoginPage ||
					isRegistration ||
					isRegistrationResponsePage ||
					isAccountActivationCongratulations), */
			"l--root--error l__app--error": isErrorPage,
			"is-capacitor no-select": isCapacitorPlatform(),
		},
		`is-${scrollDirection}`
	);

	return (
		<SuspendHeaderClassContext.Provider value={setShouldApplyHeaderClass}>
			<MainHtmlElementContext.Provider value={mainRef}>
				<div
					className={appClassName}
					style={{ padding: safeaAreaPadding }}
				>
					{isCapacitorPlatform() && (
						<div
							className="l__header__overlay"
							style={{ height: safeaAreaPadding.split(" ")[0] }}
						></div>
					)}
					<Suspense fallback={<GlobalLoader />}>
						<main
							className="l--master l__main"
							ref={(newRef) => setMainRef(newRef)}
						>
							<Header />
							{children}
							{isAuthPage && (
								<OnBoardingFooter
									isRegistration={isRegistration}
									hasOnboardingStyling={
										hasOnboardingStyling && isAuthPage
									}
								/>
							)}
						</main>

						{!isAuthPage && <Footer />}
						<CookieConsent />
					</Suspense>
				</div>
			</MainHtmlElementContext.Provider>
		</SuspendHeaderClassContext.Provider>
	);
};

export default AppLayout;
